import React, { useEffect } from 'react';
import { ApplicationStatus } from 'types';
import { PillTone, TonePill } from 'src/components/placementDrives/shared';

interface OpportunitiesCardCurrentStatusProps {
	currentStatus: ApplicationStatus;
}
const OpportunitiesCardCurrentStatus: React.FC<OpportunitiesCardCurrentStatusProps> = ({ currentStatus }) => {
	const [applicationCardState, setApplicationCardState] = React.useState<string>('');

	useEffect(() => {
		if (!currentStatus) {
			return;
		}
		if (
			currentStatus &&
			[ApplicationStatus.OPENED_BY_EMPLOYER, ApplicationStatus.OPENED_BY_ADMIN].includes(currentStatus)
		) {
			setApplicationCardState('Waiting');
		} else if (currentStatus === ApplicationStatus.SHORTLISTED) {
			setApplicationCardState('Shortlisted');
		} else if (currentStatus && [ApplicationStatus.WAITING_FOR_RECRUITER_ACTION].includes(currentStatus)) {
			setApplicationCardState('Waiting For Recruiter Action');
		} else if (
			currentStatus &&
			[ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL].includes(currentStatus)
		) {
			setApplicationCardState('Waiting For Assignment Submission Approval');
		} else if (currentStatus && [ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL].includes(currentStatus)) {
			setApplicationCardState('Waiting For Offer Letter Approval');
		} else if (currentStatus && [ApplicationStatus.QUALIFIED_ALL_ROUNDS].includes(currentStatus)) {
			setApplicationCardState('Qualified');
		} else if (currentStatus === ApplicationStatus.INTERVIEW_SCHEDULED) {
			setApplicationCardState('Interview Round In Progress');
		} else if (currentStatus === ApplicationStatus.ASSIGNMENT_IN_PROGRESS) {
			setApplicationCardState('Assignment Round In Progress');
		} else if (currentStatus === ApplicationStatus.JOBSEEKER_OPTED_OUT) {
			setApplicationCardState('Jobseeker Opted Out');
		} else if (currentStatus === ApplicationStatus.OFFER_ROLLED_OUT) {
			setApplicationCardState('Offered');
		} else if (currentStatus === ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL) {
			setApplicationCardState('Waiting For Opt Out Approval');
		} else if (currentStatus === ApplicationStatus.VERBALLY_PLACED) {
			setApplicationCardState('Placed');
		} else if (currentStatus === ApplicationStatus.PLACED) {
			setApplicationCardState('Placed');
		} else if (currentStatus === ApplicationStatus.CHANGED_OFFER_TERMS) {
			setApplicationCardState('Changed Offer Terms');
		} else if (
			currentStatus &&
			[
				ApplicationStatus.CLOSED_BY_ADMIN,
				ApplicationStatus.CLOSED_BY_RECRUITER,
				ApplicationStatus.EXPIRED,
				ApplicationStatus.OFFER_REVOKED,
				ApplicationStatus.PLACED_ELSEWHERE,
				ApplicationStatus.OFFER_REJECTED,
			].includes(currentStatus)
		) {
			const label =
				[
					ApplicationStatus.CLOSED_BY_ADMIN,
					ApplicationStatus.CLOSED_BY_RECRUITER,
					ApplicationStatus.EXPIRED,
				].includes(currentStatus) ? 'Expired' : 'Closed';
			setApplicationCardState(label);
		} else if (currentStatus && [ApplicationStatus.REJECTED].includes(currentStatus)) {
			setApplicationCardState('Rejected');
		} else {
			setApplicationCardState('Applied');
		}
	}, [currentStatus]);

	const good = ['Shortlisted', 'Qualified', 'Offered', 'Placed', 'Changed Offer Terms'];
	const stop = ['Closed', 'Expired', 'Rejected', 'Jobseeker Opted Out'];
	const wait = [
		'Waiting',
		'Waiting For Recruiter Action',
		'Waiting For Assignment Submission Approval',
		'Waiting For Offer Letter Approval',
		'Waiting For Opt Out Approval',
		'Interview Round In Progress',
		'Assignment Round In Progress',
	];
	const tone: PillTone = good.includes(applicationCardState)
		? 'good'
		: stop.includes(applicationCardState)
		  ? 'stop'
		  : wait.includes(applicationCardState)
		    ? 'wait'
		    : 'brand';

	return <TonePill tone={tone}>{applicationCardState}</TonePill>;
};

export default OpportunitiesCardCurrentStatus;
